import { render, staticRenderFns } from "./AddTeamList.vue?vue&type=template&id=a4a8d1ce&scoped=true"
import script from "./AddTeamList.vue?vue&type=script&lang=js"
export * from "./AddTeamList.vue?vue&type=script&lang=js"
import style0 from "./AddTeamList.vue?vue&type=style&index=0&id=a4a8d1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a8d1ce",
  null
  
)

export default component.exports